import { hasSufficientRole, isAtMostRole, type AuthRole } from 'auth/const'

class User {
  groups: string[]
  roles: AuthRole[]

  constructor (groups: string[], roles: AuthRole[]) {
    this.groups = groups
    this.roles = roles
  }

  canUse (role: AuthRole): boolean {
    return this.roles.filter(ur => hasSufficientRole(ur, role)).length > 0
  }

  isAtMost (role: AuthRole): boolean {
    return this.roles.every(ur => isAtMostRole(ur, role))
  }

  hasSpecific (role: AuthRole): boolean {
    return this.roles.filter(ur => ur === role).length > 0
  }

  hasAnyRole (): boolean {
    return this.roles.filter(role => this.canUse(role)).length > 0
  }
}

export default User
